import React from 'react';
import AppRouter from 'Features/App/AppRouter';

function App() {
  return <AppRouter />;
}

export default App;
